import { render } from "./aetablemodel.vue?vue&type=template&id=ed653278"
import script from "./aetablemodel.js?vue&type=script&lang=js"
export * from "./aetablemodel.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__